const ResponseConstant = {
  invalid_body_error_key: 'INVALID_BODY_ERROR_KEY',
  invalid_token_error_key: 'INVALID_TOKEN_ERROR_KEY',
  expired_token_error_key: 'EXPIRED_TOKEN_ERROR_KEY',
  invalid_captcha_token: 'INVALID_CAPTCHA_TOKEN',
  invalid_email_error_key: 'INVALID_EMAIL_ERROR_KEY',
  invalid_phone_number_error_key: 'INVALID_PHONE_NUMBER_ERROR_KEY',
  invalid_password_error_key: 'INVALID_PASSWORD_ERROR_KEY',
  invalid_job_description_error_key: 'INVALID_JOB_DESCRIPTION_ERROR_KEY',
  invalid_firstname_error_key: 'INVALID_FIRSTNAME_ERROR_KEY',
  invalid_lastname_error_key: 'INVALID_LASTNAME_ERROR_KEY',
  invalid_duplicate_error_key: 'INVALID_DUPLICATE_ERROR_KEY',
  invalid_duplicate_email_error_key: 'INVALID_DUPLICATE_EMAIL_ERROR_KEY',
  invalid_duplicate_boomerang_id_error_key: 'INVALID_DUPLICATE_BOOMERANG_ID_ERROR_KEY',
  not_found_error_key: 'NOT_FOUND_ERROR_KEY',
  unexpected_error_key: 'UNEXPECTED_ERROR_KEY',
  invalid_type_error_key: 'INVALID_TYPE_ERROR_KEY',
  invalid_account_error_key: 'INVALID_ACCOUNT_ERROR_KEY',
  no_multi_collaborator_account_error_key: 'NO_MULTI_COLLABORATOR_ACCOUNT_ERROR_KEY',
  invalid_name_error_key: 'INVALID_NAME_ERROR_KEY',
  invalid_number_error_key: 'INVALID_NUMBER_ERROR_KEY',
  empty_list_error_key: 'EMPTY_LIST_ERROR_KEY',
  not_empty_list_error_key: 'NOT_EMPTY_LIST_ERROR_KEY',
  invalid_boomerang_id_error_key: 'INVALID_BOOMERANG_ID_ERROR_KEY',
  invalid_title_error_key: 'INVALID_TITLE_ERROR_KEY',
  invalid_role_type_error_key: 'INVALID_ROLE_TYPE_ERROR_KEY',
  user_already_exists_error_key: 'USER_ALREADY_EXISTS_ERROR_KEY',
  invalid_duplicate_role_title_error_key: 'INVALID_DUPLICATE_ROLE_TITLE_ERROR_KEY',
  invalid_new_confirm_password_error_key: 'INVALID_NEW_CONFIRM_PASSWORD_ERROR_KEY',
  invalid_guarantee_error_key: 'INVALID_GUARANTEE_ERROR_KEY',
  to_many_repair_center_not_found_error_key: 'TOO_MANY_REPAIR_CENTER_FOUND_ERROR_KEY',
  repair_center_not_found_error_key: 'REPAIR_CENTER_NOT_FOUND_ERROR_KEY',
  invalid_file_to_heavy_error_key: 'INVALID_FILE_TO_HEAVY_ERROR_KEY',
  manufacturer_not_found_error_key: 'MANUFACTURER_NOT_FOUND_ERROR_KEY',
  package_not_found_error_key: 'PACKAGE_NOT_FOUND_ERROR_KEY',
  product_not_found_error_key: 'PRODUCT_NOT_FOUND_ERROR_KEY',
  transport_package_not_found_error_key: 'TRANSPORT_PACKAGE_NOT_FOUND_ERROR_KEY',
  store_not_found_error_key: 'STORE_NOT_FOUND_ERROR_KEY',
  repair_file_not_found_error_key: 'REPAIR_FILE_NOT_FOUND_ERROR_KEY',
  email_client_error_key: 'EMAIL_CLIENT_ERROR_KEY',
  email_preparer_error_key: 'EMAIL_PREPARER_ERROR_KEY',
  email_commercial_error_key: 'EMAIL_COMMERCIAL_ERROR_KEY',
  product_does_not_exist_error_key: 'PRODUCT_DOES_NOT_EXIST_ERROR_KEY',
  invalid_extension_guarantee_boomerang_error_key: 'INVALID_EXTENSION_GUARANTEE_BOOMERANG_ERROR_KEY',
  invalid_repairer_repair_file_number_error_key: 'INVALID_REPAIRER_REPAIR_FILE_NUMBER_ERROR_KEY',
  transporter_not_found_error_key: 'TRANSPORTER_NOT_FOUND_ERROR_KEY',
  invalid_constraints_error_key: 'INVALID_CONSTRAINTS_ERROR_KEY',

  expressist_transporter_link_already_exist_error_key: 'EXPRESSIST_TRANSPORTER_LINK_ALREADY_EXIST_ERROR_KEY',

  invalid_real_delivery_date_error_key: 'INVALID_REAL_DELIVERY_DATE_ERROR_KEY',

  invalid_company_name_error_key: 'INVALID_COMPANY_NAME_ERROR_KEY',
  invalid_deposit_date_error_key: 'INVALID_DEPOSIT_DATE_ERROR_KEY',
  invalid_serial_number_error_key: 'INVALID_SERIAL_NUMBER_ERROR_KEY',
  invalid_product_condition_not_found_error_key: 'INVALID_PRODUCT_CONDITION_NOT_FOUND_ERROR_KEY',
  invalid_repair_file_not_found_error_key: 'INVALID_REPAIR_FILE_NOT_FOUND_ERROR_KEY',
  invalid_recycling_folder_boomerang_id_error_key: 'INVALID_RECYCLING_FOLDER_BOOMERANG_ID_ERROR_KEY',

  failed_upload_error_key: 'FAILED_UPLOAD_ERROR_KEY',
  valid_prospect_picture_added_with_error_key: 'VALID_PROSPECT_PICTURE_ADDED_WITH_ERROR',
  invalid_recycling_boomerang_id_not_found_error_key: 'INVALID_RECYCLING_BOOMERANG_ID_NOT_FOUND_ERROR_KEY',

  itech_generic_error_key: 'ITECH_GENERIC_ERROR_KEY',
  itech_product_not_found_error_key: 'ITECH_PRODUCT_NOT_FOUND_ERROR_KEY',
  itech_client_not_found_error_key: 'ITECH_CLIENT_NOT_FOUND_ERROR_KEY',
  itech_document_integration_error_key: 'ITECH_DOCUMENT_INTEGRATION_ERROR_KEY',
  itech_environment_not_configured_error_key: 'ITECH_ENVIRONMENT_NOT_CONFIGURED_ERROR_KEY',
  not_found_supplier_code_error_key: 'NOT_FOUND_SUPPLIER_CODE_ERROR_KEY'
};

export default ResponseConstant;
